import React from "react";
import { cn } from "@/shared/lib/cn";

type SkeletonVariant = "rect" | "text" | "circle";

const VARIANT_CLASS: Record<SkeletonVariant, string> = {
    rect: "rounded-md",
    text: "rounded h-3 w-full",
    circle: "rounded-full",
};

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
    variant?: SkeletonVariant;
    /** Repete o bloco em N linhas empilhadas — a última sai mais curta. */
    lines?: number;
}

export function Skeleton({
    variant = "rect",
    lines = 1,
    className,
    ...props
}: SkeletonProps) {
    const base = cn("skeleton", VARIANT_CLASS[variant], className);

    if (lines > 1) {
        return (
            <div className="w-full space-y-2">
                {Array.from({ length: lines }).map((_, index) => (
                    <div
                        key={index}
                        className={cn(base, variant === "text" && "last:w-3/5")}
                        {...props}
                    />
                ))}
            </div>
        );
    }

    return <div className={base} {...props} />;
}
